import { render } from "./Modal-Survey.vue?vue&type=template&id=a8155a0c&scoped=true"
import script from "./Modal-Survey.vue?vue&type=script&lang=js"
export * from "./Modal-Survey.vue?vue&type=script&lang=js"

import "./Modal-Survey.vue?vue&type=style&index=0&id=a8155a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8155a0c"]])

export default __exports__